const titleCase = (input: string) => (input ? (input[0]?.toUpperCase() ?? '') + input.substring(1)
  : '');

export default titleCase;
